import RefreshIcon from '@/assets/svg/ui-elements/refresh.svg';
import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { Button, Typography } from '@/shared/design-system';

import { InlineVerificationActions, InlineVerificationContent } from './wallet-mfa.styled';
import { WalletMfaVerificationPhase } from './wallet-mfa-types';
import type { WalletMfaVerificationProps } from './wallet-mfa-verification.types';
import {
  getWalletMfaVerificationTitle,
  WalletMfaVerificationContent,
} from './wallet-mfa-verification-content';

export type { WalletMfaVerificationProps } from './wallet-mfa-verification.types';

export const WalletMfaVerificationInline = ({
  open,
  onCancel,
  fillAvailableHeight = false,
  showTitle = true,
  ...verification
}: WalletMfaVerificationProps & { fillAvailableHeight?: boolean; showTitle?: boolean }) => {
  const isMobile = useIsMobile();

  if (!open) return null;

  const title = getWalletMfaVerificationTitle(verification.purpose);
  const actionSize = fillAvailableHeight ? 'lg' : 'md';
  const primaryAction =
    verification.phase === WalletMfaVerificationPhase.Totp ? (
      <Button
        size={actionSize}
        disabled={verification.code.length !== 6}
        onClick={verification.onVerifyCode}
      >
        Verify
      </Button>
    ) : verification.phase === WalletMfaVerificationPhase.Error ? (
      <Button size={actionSize} onClick={verification.onRestart}>
        <RefreshIcon />
        Try again
      </Button>
    ) : null;

  return (
    <InlineVerificationContent
      $fillAvailableHeight={fillAvailableHeight}
      role="region"
      aria-label={title}
    >
      {showTitle && (
        <Typography variant="body2" fontWeight={500}>
          {title}
        </Typography>
      )}
      <WalletMfaVerificationContent {...verification} showErrorRetry={false} />
      <InlineVerificationActions $pageLayout={fillAvailableHeight}>
        {isMobile && primaryAction}
        <Button size={actionSize} variant="outline" onClick={onCancel}>
          Back
        </Button>
        {!isMobile && primaryAction}
      </InlineVerificationActions>
    </InlineVerificationContent>
  );
};
